// import querystring from 'querystring-browser';
import getVideoFeedUrl from 'helpers/feeds/videoHelpers';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from 'reduxUtils/reducerRegistry';
import _get from 'lodash.get';
import decodeHtml from 'utils/htmlDecoder';
// import { TOI_FEED_DOMAIN } from '../../constants';
import makeRequest from 'utils/makeRequest';
import {
  getMsidFromPath,
  appendGrxParams,
  isGrxIdEmpty,
  getGrxObject,
  getCloudServiceItemUrl,
} from 'utils/common';
import {
  // CARDS_ARTICLESHOW_JSON_URL,
  CARDS_TOPIC_TREE_STORY_BUNDLE_JSON_URL,
  // CARDS_TOPIC_TREE_JSON_URL,
  PERSONALIZE_UP_NEXT_V2_API,
  // CARDS_ARTICLESHOW_JSON_URL_V2_LITE,
  PERSONALIZE_UP_NEXT_V2_API_DEFAULT,
  SIGNAL_PARAMETER,
  PERSONALISE_API_EMPTY_RESPONSE_MESSAGE,
  PERSONALISE_API_DOWN_MESSAGE,
  UNIFIED_FEED_DOMAIN,
  UNIFIED_FEED_DOMAIN_SERVICE,
  // TOI_LIVE_DOMAIN,
} from 'constants/index.js';
import {
  receivePrimeshowData,
  // recievePrimeshowCardsData,
  receivePrimeshowBundleHashtag,
  primeshowDataLoading,
  primeshowDataLoaded,
  // recieveUpNextData,
} from 'routes/toiplusprimeshow/redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  getSectionMsidMapping,
  getBodyInserts,
  readAlsoWidgetCityMapping,
  readAlsoWidgetApplicableCities,
} from './config';
// import classNames from 'classnames';

const PERSONALIZE_UP_NEXT_V2 = appendGrxParams(PERSONALIZE_UP_NEXT_V2_API);
const reducerName = 'articleshow_v2';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

export const RECEIVE_SECTION_DATA = createActionName('RECEIVE_SECTION_DATA');
export const HANDLE_SECTION_DATA_ERROR = createActionName(
  'HANDLE_SECTION_DATA_ERROR',
);

// export const TOGGLE_NIC = createActionName('TOGGLE_NIC');
// export const RECEIVE_DATA_NIC = createActionName('RECEIVE_DATA_NIC');
// export const NIC_LOADING = createActionName('NIC_LOADING');
// export const NIC_LOADED = createActionName('NIC_LOADED');
export const DATA_LOADING = createActionName('DATA_LOADING');
export const DATA_LOADED = createActionName('DATA_LOADED');
export const ADD_DOCK_CANDIDATE = createActionName('ADD_DOCK_CANDIDATE');
export const ADD_UNDOCK_CANDIDATE = createActionName('ADD_UNDOCK_CANDIDATE');
export const DELETE_DOCK_CANDIDATE = createActionName('DELETE_DOCK_CANDIDATE');
export const DELETE_UNDOCK_CANDIDATE = createActionName(
  'DELETE_UNDOCK_CANDIDATE',
);
export const OPEN_VIDEO_THEATRE = createActionName('OPEN_VIDEO_THEATRE');
export const CLOSE_VIDEO_THEATRE = createActionName('CLOSE_VIDEO_THEATRE');
export const RECEIVE_DATA_VIDEO_THEATRE_SLIDER = createActionName(
  'RECEIVE_DATA_VIDEO_THEATRE_SLIDER',
);
export const ADD_NEXT_VIDEO_MSID = createActionName('ADD_NEXT_VIDEO_MSID');
export const ELECTIONS_DATA_LOADED = createActionName('ELECTIONS_DATA_LOADED');
export const EXITPOLL_DATA_LOADED = createActionName('EXITPOLL_DATA_LOADED');
export const ASBREIFS_DATA_LOADED = createActionName('ASBREIFS_DATA_LOADED');
export const NIC_TEXT = createActionName('NIC_TEXT');
// export const ASNEWSCOVERAGE_DATA_LOADED = createActionName(
//   'ASNEWSCOVERAGE_DATA_LOADED',
// );
export const GEOLOCATION_VALUE = createActionName('GEOLOCATION_VALUE');
export const ACTIVE_MSID = createActionName('ACTIVE_MSID');
export const LOAD_MINITV_COMPONENT = createActionName('LOAD_MINITV_COMPONENT');
export const ARTICLE_TO_SHOW_COUNT = createActionName('ARTICLE_TO_SHOW_COUNT');
export const ARTICLE_TO_SHOW_RESET_DAYS = createActionName(
  'ARTICLE_TO_SHOW_RESET_DAYS',
);
export const RECEIVE_CARDS_INSERT_DATA = createActionName(
  'RECEIVE_CARDS_INSERT_DATA',
);
// export const RECEIVE_BUNDLE_CARDS_DATA = createActionName(
//   'RECEIVE_BUNDLE_CARDS_DATA',
// );
export const HANDLE_CARDS_INSERTS_DATA_ERROR = createActionName(
  'HANDLE_CARDS_INSERTS_DATA_ERROR',
);
export const RECIEVE_BUNDLE_HASHTAG_DATA = createActionName(
  'RECIEVE_BUNDLE_HASHTAG_DATA',
);

export const RECEIVE_DATA_RELATED_ARTICLES = createActionName(
  'RECEIVE_DATA_RELATED_ARTICLES',
);

export const RECEIVE_CARDS_INSERT_LITE_DATA = createActionName(
  'RECEIVE_CARDS_INSERT_LITE_DATA',
);

export const HANDLE_CARDS_INSERTS_DATA_LITE_ERROR = createActionName(
  'HANDLE_CARDS_INSERTS_DATA_LITE_ERROR',
);

export const RECEIVE_BOARD_DATA = createActionName('RECEIVE_BOARD_DATA');
export const RECEIVE_BOARD_DATA_ERROR = createActionName(
  'RECEIVE_BOARD_DATA_ERROR',
);
export const RECEIVE_TRIBUTE_SHOW_DATA = createActionName(
  'RECEIVE_TRIBUTE_SHOW_DATA',
);

export const OPEN_MWEB_SEARCH = createActionName('OPEN_MWEB_SEARCH');
export const SET_IS_ORGANIC = createActionName('SET_IS_ORGANIC');
export const SET_IS_PAID_TRAFFIC = createActionName('SET_IS_PAID_TRAFFIC');

export const SHOW_SEARCH_OVERLAY = createActionName('SHOW_SEARCH_OVERLAY');

export const RECEIVE_CARDS_DATA = createActionName('RECEIVE_CARDS_DATA');

export const PERPETUAL_DATA = createActionName('PERPETUAL_DATA');
export const HANDLE_UP_NEXT_ERROR = createActionName('HANDLE_UP_NEXT_ERROR');

export const POPULATE_ARTICLESHOW_WIDGETS = createActionName(
  'POPULATE_ARTICLESHOW_WIDGETS',
);

let PersonaliseGrxInfo = {};
// action creators
function receiveArticleshowData(data, params) {
  return {
    type: RECEIVE_DATA,
    payload: {
      data,
      msid: data.id,
      params,
    },
  };
}

function receiveNewSectionInfo(data, params) {
  return {
    type: RECEIVE_SECTION_DATA,
    payload: {
      data,
      msid: params.msid,
      params,
    },
  };
}

function handleArticleshowDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}
export function recieveUpNextData(perpetualCardsData) {
  return {
    type: PERPETUAL_DATA,
    payload: perpetualCardsData,
  };
}
export function handleUpNextError(data) {
  return {
    type: HANDLE_UP_NEXT_ERROR,
    payload: data,
  };
}

function handleBoradResultError(error) {
  return {
    type: RECEIVE_BOARD_DATA_ERROR,
    error,
  };
}

function generateFullUrl(url, params) {
  let finalUrl = url;
  if (Object.keys(params).length) {
    // finalUrl = finalUrl.indexOf('?')<0? `${finalUrl}?`:`${finalUrl}&`;
    // finalUrl += '?';
    // eslint-disable-next-line array-callback-return
    Object.keys(params).map((_, k) => {
      finalUrl = `${finalUrl + _}=${params[_]}`;
      if (k !== Object.keys(params).length - 1) {
        finalUrl += '&';
      }
    });
  }
  return finalUrl;
}
function grxFailure(data) {
  const { slotName, body, apiCalled } = data;
  const bodyStruct = { ...body };
  analyticsWrapper('grx', 'track', 'Signals_Failure', {
    signalEventType: 'Signals_Failure',
    slot_name: slotName,
    api_called: apiCalled,
    body: JSON.stringify(bodyStruct),
  });
}
export function fetchUpNextData(params) {
  const finalUrl = generateFullUrl(PERSONALIZE_UP_NEXT_V2, params);
  return makeRequest.get(
    `${finalUrl}${SIGNAL_PARAMETER}`,
    {},
    'skipfeedengine',
  );
}

function fetchUpNextDefaultData() {
  return makeRequest.get(
    PERSONALIZE_UP_NEXT_V2_API_DEFAULT,
    {},
    'skipfeedengine',
  );
}

const getErrorMessageAndCode = (data = {}) => {
  let code = '';
  let message = '';
  const { messages } = data;
  if (messages?.length) {
    for (let i = 0; i < messages.length; i += 1) {
      code = code
        ? `${code}|||${messages[i].code}`
        : messages[i]?.code.toString();
      message = message
        ? `${message}|||${messages[i].message}`
        : messages[i].message;
    }
  }
  return { code, message };
};
export function getUpNextDefaultData(params) {
  return dispatch =>
    fetchUpNextDefaultData()
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.inserts &&
          data.data.inserts['above-bottom-of-article']
        ) {
          const cardsObj = data.data.inserts['above-bottom-of-article'];
          if (
            typeof cardsObj === 'object' &&
            Object.keys(cardsObj).length > 0
          ) {
            const grxInfo = {
              ...PersonaliseGrxInfo,
              algorithm_version: data.data.algorithm_version,
              signalEventType: 'Signals_View_Default',
            };
            dispatch(
              recieveUpNextData({
                cardsObj,
                grxInfo,
                msid: params.msid,
              }),
            );
          } else {
            grxFailure(PersonaliseGrxInfo);
          }
        }
      })
      .catch(() => {
        grxFailure(PersonaliseGrxInfo);
      });
}
export function getperpetualData(params) {
  const { msid, ...restParams } = params;
  const apiUrl = generateFullUrl(PERSONALIZE_UP_NEXT_V2, restParams);
  return dispatch => {
    const grxData = isGrxIdEmpty(apiUrl);
    if (grxData) {
      // dispatch(handleUpNextError(grxData));
      PersonaliseGrxInfo = grxData;
      dispatch(getUpNextDefaultData(params));
      return;
    }
    fetchUpNextData(restParams)
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.inserts &&
          data.data.inserts['above-bottom-of-article']
        ) {
          const cardsObj = data.data.inserts['above-bottom-of-article'];
          if (
            typeof cardsObj === 'object' &&
            Object.keys(cardsObj).length > 0
          ) {
            let body = {};
            if (data.data.hasWarning) {
              const error = getErrorMessageAndCode(data.data);
              body = { ...error };
            } else {
              body = {
                code: data?.status.toString(),
                message: data?.statusText || 'success',
              };
            }
            const grxInfo = getGrxObject({
              slotName: 'up-next',
              algorithm_version: data.data.algorithm_version,
              hasWarning: data.data?.hasWarning,
              body,
              apiUrl,
              signalEventType: data.data.hasWarning
                ? 'Signals_View_Suboptimal'
                : 'Signals_View',
            });
            dispatch(
              recieveUpNextData({
                cardsObj,
                grxInfo,
                msid,
              }),
            );
          } else {
            // if the response is present but data is empty
            const body = {
              code: data?.status.toString(),
              message:
                data?.statusText || PERSONALISE_API_EMPTY_RESPONSE_MESSAGE,
              msid: [],
            };
            const grxInfo = getGrxObject({ body, apiUrl, slotName: 'up-next' });
            PersonaliseGrxInfo = grxInfo;
            dispatch(handleUpNextError(grxInfo));
            dispatch(getUpNextDefaultData(params));
          }
        }
      })
      .catch(error => {
        const { data, status, statusText } = error.response;
        const code = status.toString();
        const grxMessage = statusText || PERSONALISE_API_DOWN_MESSAGE;
        let body = {};
        if (status >= 400 && status <= 499 && status !== 404) {
          const errorObj = getErrorMessageAndCode(data);
          body = { ...errorObj, msid: [] };
        } else {
          // in case the api is giving 404(wrong client side url) or 500(server down)
          body = {
            code,
            message: grxMessage,
            msid: [],
          };
        }
        const grxInfo = getGrxObject({ body, apiUrl, slotName: 'up-next' });
        PersonaliseGrxInfo = grxInfo;
        dispatch(handleUpNextError(grxInfo));
        dispatch(getUpNextDefaultData(params));
      });
  };
}

// export function toggleNIC(isOpen) {
//   return {
//     type: TOGGLE_NIC,
//     payload: {
//       isNicOpen: isOpen,
//     },
//   };
// }

// function nicLoading() {
//   return {
//     type: NIC_LOADING,
//     payload: {},
//   };
// }
// function nicLoaded() {
//   return {
//     type: NIC_LOADED,
//     payload: {},
//   };
// }
// function receiveNicData(url, data) {
//   return {
//     type: RECEIVE_DATA_NIC,
//     payload: {
//       nic: {
//         url,
//         data: data.data,
//       },
//     },
//   };
// }

function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

// function receiveCardInsertLiteData(data) {
//   return {
//     type: RECEIVE_CARDS_INSERT_LITE_DATA,
//     payload: data,
//   };
// }

// function handleCardInsertLiteDataError() {
//   return {
//     type: HANDLE_CARDS_INSERTS_DATA_LITE_ERROR,
//     payload: {},
//   };
// }

function receiveElectionsData(data) {
  return {
    type: ELECTIONS_DATA_LOADED,
    payload: data.data,
  };
}

function receiveBundleHashtag(data) {
  return {
    type: RECIEVE_BUNDLE_HASHTAG_DATA,
    payload: data,
  };
}

function receiveExitPollData(data) {
  return {
    type: EXITPOLL_DATA_LOADED,
    payload: data.data,
  };
}
function receiveAsBreifsData(data) {
  return {
    type: ASBREIFS_DATA_LOADED,
    payload: data.data,
  };
}

// function receiveNewsCoverageData(data) {
//   return {
//     type: ASNEWSCOVERAGE_DATA_LOADED,
//     payload: data.data,
//   };
// }

export function addDockCandidate(data) {
  return {
    type: ADD_DOCK_CANDIDATE,
    payload: {
      data,
    },
  };
}
export function addUnDockCandidate(data) {
  return {
    type: ADD_UNDOCK_CANDIDATE,
    payload: {
      data,
    },
  };
}
export function deleteDockCandidate() {
  return {
    type: DELETE_DOCK_CANDIDATE,
    payload: {},
  };
}
export function deleteUnDockCandidate() {
  return {
    type: DELETE_UNDOCK_CANDIDATE,
    payload: {},
  };
}

export function openVideoTheatre(sliderPath, currId, currItem) {
  return {
    type: OPEN_VIDEO_THEATRE,
    payload: {
      videoTheatreSliderPath: sliderPath,
      videoTheatreCurrMsid: currId,
      videoTheatreCurrItem: currItem,
    },
  };
}
export function closeVideoTheatre() {
  return {
    type: CLOSE_VIDEO_THEATRE,
    payload: {},
  };
}

export function loadMiniTvComponentV2(loadedMiniTvComponent) {
  return {
    type: LOAD_MINITV_COMPONENT,
    payload: loadedMiniTvComponent,
  };
}

function recieveVideoTheatreSliderData(data) {
  return {
    type: RECEIVE_DATA_VIDEO_THEATRE_SLIDER,
    payload: {
      data: data.data,
    },
  };
}

function receiveRelatedArticlesData(data) {
  return {
    type: RECEIVE_DATA_RELATED_ARTICLES,
    payload: {
      data: data.data,
    },
  };
}

export function addNextVideoMsid(msidForNextVideo, slikeId) {
  return {
    type: ADD_NEXT_VIDEO_MSID,
    payload: { msidForNextVideo, slikeId },
  };
}

export function updateActiveMsid(msid) {
  return {
    type: ACTIVE_MSID,
    payload: {
      activemsid: msid,
    },
  };
}

export function populateArticleshowWidgets(params) {
  return {
    type: POPULATE_ARTICLESHOW_WIDGETS,
    payload: {
      msid: params.msid,
      sectionInfo: params.sectionInfo,
      isMobile: params.isWapView,
      isEtimesArticle: params.isEtimesArticle,
    },
  };
}

export function updateArticleToShowCount(data) {
  return {
    type: ARTICLE_TO_SHOW_COUNT,
    payload: data,
  };
}

export function updateArticleToShowResetDays(data) {
  return {
    type: ARTICLE_TO_SHOW_RESET_DAYS,
    payload: data,
  };
}

// export function saveGeoLocationValue(value) {
//   return {
//     type: GEOLOCATION_VALUE,
//     payload: {
//       geolocationValue: value,
//     },
//   };
// }

/*
function getProtocol() {
  let protocol = 'http';
  if (typeof window !== 'undefined') {
    protocol = 'https';
  }
  return protocol;
}
*/

export function updateMwebOpenSearchStatus(data) {
  return { type: OPEN_MWEB_SEARCH, payload: data };
}
function recieveCardsData(data) {
  return {
    type: RECEIVE_CARDS_DATA,
    payload: {
      ...data,
    },
  };
}
// function receiveBundleCardData(bundleUrl, data) {
//   return {
//     type: RECEIVE_BUNDLE_CARDS_DATA,
//     payload: {
//       data,
//       bundleUrl,
//     },
//   };
// }

function receiveBoardResultData(data) {
  if (data && data.status === 200 && data.data) {
    const resultData = data.data;
    return {
      type: RECEIVE_BOARD_DATA,
      payload: resultData,
    };
  }

  return {
    type: RECEIVE_BOARD_DATA,
    payload: {},
  };
}

export function updateSearchOverlayStatus(data) {
  return { type: SHOW_SEARCH_OVERLAY, payload: data };
}

//data gatherers
function fetchArticleshowData(params, isAppView, dispatch) {
  dispatch(dataLoading());
  dispatch(primeshowDataLoading()); // @TODO Migrating to Toiplusprimeshow
  const appParameter = isAppView ? '&frmapp=yes' : '';
  // this code is temporary
  const primeuser = params.frmprime === 'yes' ? '&isprime=true' : '';
  const isClientConsumable = params.isClientConsumable
    ? '&test=consumable'
    : '';
  const isTestOutstream = params.isTestOutstream ? '&test=outstream' : '';
  const isClientConsumableV2 = params.isClientConsumableV2
    ? '&test=consumable_V2'
    : '';
  const articlePath = `/articleshow/${getMsidFromPath(params.fullPath)}.cms`;
  const isWapView = !!params.isWapView;
  const reviewsPageParam = params.isReviewsPage
    ? '&isreviewspage=yes&isreviewsnewdomain=yes'
    : '';
  const isPromoshow =
    params?.fullPath?.indexOf('promoshow') > -1 ? `&ispromoshow=true` : ``;
  const url = `${getFeedUrl()}/toi/web/show/news?version=v2&path=${articlePath}${appParameter}${isClientConsumable}${isTestOutstream}${isClientConsumableV2}${primeuser}${isPromoshow}${reviewsPageParam}`;
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchArticleshowDataNew(params, isAppView, dispatch) {
  dispatch(dataLoading());
  dispatch(primeshowDataLoading()); // @TODO Migrating to Toiplusprimeshow
  const appParameter = isAppView ? '&frmApp=true' : '';

  const primeuser = params.frmprime === 'yes' ? '&isPrimeUser=true' : '';

  const isWapView = !!params.isWapView;
  const url = `${UNIFIED_FEED_DOMAIN}/wufs/show/article?source=toi&dm=t${appParameter}&isMobile=${isWapView}&msid=${getMsidFromPath(
    params.fullPath,
  )}${primeuser}&client=toi`;

  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchNewSectionInfo(baseUrl, bodyData = {}) {
  const jsonString = JSON.stringify(bodyData);
  const encodedData = encodeURIComponent(jsonString);
  const url = `${baseUrl}?detailsParam=${encodedData}`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

// function fetchNICData(nicUrl) {
//   const articlePath = `/articleshow/${getMsidFromPath(nicUrl)}.cms`;
//   const url = `${getFeedUrl()}/toi/web/show/news?version=v2&path=${articlePath}`;
//   return makeRequest.get(url);
// }

function fetchVideoTheatreSliderData(sliderUrl, isWapView) {
  let url = sliderUrl;
  if (sliderUrl && sliderUrl.startsWith('https://')) {
    // const regexForExtractingSectionUrl = /^(http\:|https\:)(\/\/timesofindia.indiatimes.com\/)(\D+)(\/\D+\/)(videoshow\/\d+.cms)$/;
    const tempUrl = sliderUrl
      .replace('https://timesofindia.indiatimes.com/', '')
      .replace('https://toidev.indiatimes.com/', '')
      .replace(/\/videoshow\/\d+.cms/, '')
      .split('/');
    tempUrl.pop();
    url = getVideoFeedUrl({
      path: `/${tempUrl.join('/')}`,
      perpage: 10,
    });
  }
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchElectionsData(url, isWapView) {
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchExitPoll(url, isWapView) {
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchAsBreifs(url, isWapView) {
  return makeRequest.get(url, { isMobile: isWapView });
}

function fetchRelatedArticles(url) {
  return makeRequest.get(url, {}, 'skipfeedengine');
}

// function fetchCardsInsertLite() {
//   return makeRequest.get(CARDS_ARTICLESHOW_JSON_URL_V2_LITE, 'skipfeedengine');
// }

function fetchCardData({ msid }) {
  const url = `https://api-newscard.indiatimes.com/toi-plus/web/${msid}.json`;
  return makeRequest.get(url);
}

function fetchBoradResultData(metaInfo) {
  const urlBoardResult = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/utility/result/page/init?msid=${
    metaInfo.Matchid
  }`;
  return makeRequest.get(urlBoardResult, 'skipfeedengine');
}

function fetchTributeShowData(params) {
  const requestParams = {
    params: {},
  };
  const feedPath = '/ufs-utility/utility/show/';
  const url = `${UNIFIED_FEED_DOMAIN}${feedPath}tribute?msid=${
    params?.msid
  }&dm=t&pc=toi&client=toi`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

export function reciveTributeShowData(data) {
  return {
    type: RECEIVE_TRIBUTE_SHOW_DATA,
    payload: data,
  };
}

// function fetchBundleCardData(bundleUrl) {
//   try {
//     return makeRequest.get(`${bundleUrl}.json`, 'skipfeedengine');
//   } catch (err) {
//     throw err;
//   }
// }
//exposed functions
export function loadArticleshowData(params, isAppView) {
  return dispatch =>
    new Promise(resolve => {
      fetchArticleshowData(params, isAppView, dispatch)
        .then(data => {
          dispatch(dataLoaded());
          dispatch(primeshowDataLoaded()); // @TODO Migrating to Toiplusprimeshow
          dispatch(receiveArticleshowData(data.data, params));
          dispatch(receivePrimeshowData(data.data, params)); // @TODO  Migrating to toiplusprimeshow state
          resolve('1'); // To check & return data load status
        })
        .catch(error => {
          dispatch(dataLoaded());
          dispatch(primeshowDataLoaded());
          dispatch(handleArticleshowDataError(error));
          resolve('0');
        });
    });
}

export function loadArticleshowDataNew(params, isAppView) {
  return dispatch =>
    new Promise(resolve => {
      fetchArticleshowDataNew(params, isAppView, dispatch)
        .then(data => {
          dispatch(dataLoaded());
          dispatch(primeshowDataLoaded()); // @TODO Migrating to Toiplusprimeshow
          dispatch(receiveArticleshowData(data.data, params));
          dispatch(receivePrimeshowData(data.data, params)); // @TODO  Migrating to toiplusprimeshow state
          resolve('1'); // To check & return data load status
        })
        .catch(error => {
          dispatch(dataLoaded());
          dispatch(primeshowDataLoaded());
          dispatch(handleArticleshowDataError(error));
          resolve('0');
        });
    });
}

export function loadTributeShowData(params) {
  return dispatch =>
    fetchTributeShowData(params)
      .then(response => {
        dispatch(reciveTributeShowData(response.data, params));
      })
      .catch(error => {
        console.log('error', error);
      });
}

export function loadExternalWidgetData(params) {
  const widgetMapping = params.widgetMapping || {};
  const externalDataObjects = Object.values(widgetMapping).filter(
    widget => widget.dataUrl,
  );
  const externalUrls = externalDataObjects.map(item => item.dataUrl);
  const externalPromises = externalUrls.map(url =>
    makeRequest.get(url, {}, 'skipfeedengine'),
  );
  return dispatch =>
    Promise.all(externalPromises)
      .then(data => {
        const responseObj = {};
        if (Array.isArray(data) && data.length > 0) {
          data.forEach(responseData => {
            if (responseData && responseData.status === 200) {
              if (
                Array.isArray(externalDataObjects) &&
                externalDataObjects.length > 0
              ) {
                externalDataObjects.forEach(item => {
                  let responseItems =
                    responseData?.data?.items || responseData.data;
                  if (
                    responseData &&
                    responseData?.data?.jsonFeed?.data?.items
                  ) {
                    responseItems = responseData?.data?.jsonFeed?.data?.items;
                  }
                  if (
                    responseItems &&
                    typeof responseItems === 'object' &&
                    item.responseKey &&
                    responseItems[item.responseKey]
                  ) {
                    responseItems = responseItems[item.responseKey];
                  }
                  let widgetTitle = item.title;
                  if (
                    responseData &&
                    responseData.config &&
                    responseData.config.url &&
                    responseData.config.url === item.dataUrl
                  ) {
                    if (item.isCloudServiceData) {
                      widgetTitle =
                        widgetTitle ||
                        (responseData.data &&
                          responseData.data.response &&
                          Array.isArray(responseData.data.response.data) &&
                          responseData.data.response.data.length > 0 &&
                          responseData.data.response.data[0].title);

                      responseItems =
                        (responseData.data &&
                          responseData.data.response &&
                          Array.isArray(responseData.data.response.data) &&
                          responseData.data.response.data.length > 0 &&
                          responseData.data.response.data[0].children) ||
                        [];
                    }
                    if (item.isGlobalFeedData) {
                      widgetTitle =
                        responseData &&
                        responseData.data &&
                        typeof responseData.data === 'object' &&
                        responseData.data.title
                          ? responseData.data.title
                          : '';

                      if (
                        params &&
                        params.widgetMapping &&
                        params.widgetMapping.hteWidget &&
                        typeof params.widgetMapping.hteWidget === 'object'
                      ) {
                        params.widgetMapping.hteWidget.name = widgetTitle;
                      }

                      responseItems =
                        responseData &&
                        responseData.data &&
                        responseData.data.items &&
                        Array.isArray(responseData.data.items) &&
                        responseData.data.items.length > 0
                          ? responseData.data.items
                          : [];
                    }

                    if (
                      item.msid &&
                      responseItems &&
                      Array.isArray(responseItems) &&
                      responseItems.length > 0
                    ) {
                      responseObj[item.msid] = responseItems.slice(
                        0,
                        item.itemCount || responseItems.length,
                      );
                      if (item.isCloudServiceData) {
                        responseObj[item.msid] = responseObj[item.msid].map(
                          newsItem => ({
                            ...newsItem,
                            wu: getCloudServiceItemUrl(newsItem),
                            widgetTitle,
                          }),
                        );
                      }
                      if (item.isGlobalFeedData) {
                        responseObj[item.msid] = responseObj[item.msid].map(
                          newsItem => ({
                            ...newsItem,
                            title: newsItem.hl,
                          }),
                        );
                      }
                    }
                  }
                });
              }
            }
          });
        }
        dispatch(receiveNewSectionInfo(responseObj, params));
      })
      .catch(() => {
        dispatch(receiveRelatedArticlesData({}));
      });
}

export function loadNewSectionInfo(params) {
  const widgetMapping = params.widgetMapping || {};

  const bodyData = getSectionMsidMapping(widgetMapping);

  const url = `${UNIFIED_FEED_DOMAIN}/wufs/feed/fetch/widgets/data`;
  return dispatch =>
    fetchNewSectionInfo(url, bodyData)
      .then(data => {
        let responseData;
        let responseObj;

        if (data && data.data && data.data.params) {
          responseData = data.data.params;
          responseObj = {};
          if (Array.isArray(bodyData) && bodyData.length > 0) {
            bodyData.forEach(item => {
              if (
                item.msid &&
                responseData &&
                responseData[item.msid] &&
                responseData[item.msid][item.apiType] &&
                responseData[item.msid][item.apiType].items
              ) {
                responseObj[item.msid] =
                  responseData[item.msid][item.apiType].items;
              }
            });
          }
        }
        dispatch(receiveNewSectionInfo(responseObj, params));
      })
      .catch(() => {
        dispatch(receiveRelatedArticlesData({}));
      });
}

export function loadRelatedArticles(msid, isDesktop) {
  const url = `/feeds/feed_relatedcontent_csr.cms?feedtype=json&tag=relatedcontentwdt&config.perpage=${
    isDesktop ? 4 : 8
  }&count=${isDesktop ? 4 : 8}&msid=${msid}`;
  return dispatch =>
    fetchRelatedArticles(url)
      .then(data => dispatch(receiveRelatedArticlesData(data)))
      .catch(() => {
        // console.log('somthing went wrong with loadRelatedArticles');
        dispatch(receiveRelatedArticlesData({}));
      });
}

export function getCardData(params) {
  return dispatch => {
    dispatch(dataLoading());
    dispatch(primeshowDataLoading()); // @TODO Migrating to Toiplusprimeshow
    return fetchCardData(params)
      .then(data => {
        if (data && data.status === 200) {
          dispatch(dataLoaded());
          dispatch(primeshowDataLoaded()); // @TODO Migrating to Toiplusprimeshow
          dispatch(recieveCardsData(data.data, params));
          // dispatch(recievePrimeshowCardsData(data.data, params)); // @TODO Migrating to Toiplusprimeshow
        }
      })
      .catch(dispatch(dataLoaded()));
  };
}

// export function loadCardInsertLiteData() {
//   return dispatch =>
//     fetchCardsInsertLite()
//       .then(response => {
//         dispatch(receiveCardInsertLiteData(response.data));
//       })
//       .catch(error => {
//         dispatch(handleCardInsertLiteDataError(error));
//       });
// }

export function fetchBundleHashtag(topicUrl) {
  return makeRequest.get(
    `${CARDS_TOPIC_TREE_STORY_BUNDLE_JSON_URL}${topicUrl}.json`,
    'skipfeedengine',
  );
}

export function setNICLabel(text) {
  return {
    type: NIC_TEXT,
    payload: {
      text,
    },
  };
}

// export function loadNIC(nicUrl) {
//   return dispatch => {
//     dispatch(nicLoading());
//     fetchNICData(nicUrl)
//       .then(data => dispatch(receiveNicData(nicUrl, data)))
//       .then(() => dispatch(nicLoaded()))
//       .catch(error => dispatch(handleArticleshowDataError(error)));
//   };
// }
// export function getBundleCardData(bundleUrlObj) {
//   if (bundleUrlObj.topicUrl) {
//     bundleUrlObj = {
//       ...bundleUrlObj,
//       topicUrl: `${CARDS_TOPIC_TREE_JSON_URL + bundleUrlObj.topicUrl}`,
//     };
//   }
//   if (bundleUrlObj.sectionUrl) {
//     bundleUrlObj = {
//       ...bundleUrlObj,
//       sectionUrl: `${CARDS_ARTICLESHOW_JSON_URL}web${bundleUrlObj.sectionUrl}`,
//     };
//   }
//   return dispatch => {
//     fetchBundleCardData(bundleUrlObj.topicUrl || bundleUrlObj.sectionUrl)
//       .then(resp => {
//         if (
//           resp.data &&
//           resp.data.inserts &&
//           resp.data.inserts['bottom-of-article']
//         ) {
//           return new Promise(resolve => {
//             resolve({
//               data: resp.data,
//               bundleUrl: bundleUrlObj.topicUrl || bundleUrlObj.sectionUrl,
//             });
//           });
//         }
//         return fetchBundleCardData(bundleUrlObj.sectionUrl);
//       })
//       .catch(err => {
//         if (err && err.config.url !== `${bundleUrlObj.sectionUrl}.json`) {
//           return fetchBundleCardData(bundleUrlObj.sectionUrl);
//         }
//         throw err;
//       })
//       .then(innerData =>
//         dispatch(
//           receiveBundleCardData(
//             `${innerData.bundleUrl || bundleUrlObj.sectionUrl}.json`,
//             innerData.data,
//           ),
//         ),
//       );
//   };
// }
export function loadVideoTheatreSlider(url, isWapView) {
  return dispatch =>
    fetchVideoTheatreSliderData(url, isWapView).then(data =>
      dispatch(recieveVideoTheatreSliderData(data)),
    );
  // .catch(error => false);
}

export function loadElections(url, isWapView) {
  return dispatch =>
    fetchElectionsData(url, isWapView).then(data =>
      dispatch(receiveElectionsData(data)),
    );
  // .catch(error => false);
}
export function getBundleHashtag(topicUrl) {
  return dispatch =>
    fetchBundleHashtag(topicUrl).then(resp => {
      dispatch(receiveBundleHashtag(resp.data));
      dispatch(receivePrimeshowBundleHashtag(resp.data)); // @TODO Migrating to Toiplusprimeshow
    });
}

export function loadExitPoll(url, isWapView) {
  return dispatch =>
    fetchExitPoll(url, isWapView).then(data =>
      dispatch(receiveExitPollData(data)),
    );
  // .catch(error => false);
}
export function loadAsBreifs(url, isWapView) {
  return dispatch =>
    fetchAsBreifs(url, isWapView).then(data =>
      dispatch(receiveAsBreifsData(data)),
    );
  // .catch(error => false);
}

export function setIsOrganic(isOrganic) {
  return {
    type: SET_IS_ORGANIC,
    payload: isOrganic,
  };
}

export function setIsPaidTraffic(isPaidTraffic) {
  return {
    type: SET_IS_PAID_TRAFFIC,
    payload: isPaidTraffic,
  };
}

// export function loadNewsCoverage(url) {
//   return dispatch =>
//     fetchNewsCoverage(url).then(data =>
//       dispatch(receiveNewsCoverageData(data)),
//     );
//   // .catch(error => false);
// }

export function loadBoardResultData(metaInfo) {
  return dispatch =>
    fetchBoradResultData(metaInfo)
      .then(data => dispatch(receiveBoardResultData(data)))
      .catch(error => dispatch(handleBoradResultError(error.message)));
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      const articleShowData = state.data ? { ...state.data } : {};
      articleShowData[action.payload.msid] = action.payload.data;
      let articleData = articleShowData[action.payload.msid];
      const isCardCMS =
        _get(articleData, `metaInfo.CARDPAGETEMPLATE`) === 'cardhd';
      if (isCardCMS && articleData.ads) {
        articleData.ads = {};
      }
      if (action.payload.params && action.payload.params.isNewFeedEnabled) {
        // Deconstruct all widgets configured for the section and assign them to the articleData
        const widgetMapping = action.payload.params.widgetMapping || {};
        if (typeof widgetMapping === 'object') {
          articleData = { ...articleData, ...widgetMapping };
        }
        if (
          articleData &&
          articleData.navsubsecs &&
          articleData.navsubsecs.subsec1 &&
          articleData.navsubsecs.subsec1.subsecname1 === 'Life-&-Style'
        ) {
          articleData.navsubsecs.subsec1.subsecname1 = 'Life & Style';
        }
        if (
          articleData &&
          Array.isArray(articleData.images) &&
          articleData.images.length > 0
        ) {
          articleData.images = articleData.images.map(image => {
            if (image.cap) {
              try {
                image.cap = decodeHtml(image.cap);
              } catch (e) {
                image.cap = image.cap;
              }
            }
            return image;
          });
        }
      }

      articleShowData[action.payload.msid] = articleData;
      return {
        ...state,
        // seoData: action.payload.seoData,
        // maxAge: action.payload.maxAge,
        // adsData: action.payload.adsData,
        // mobileAdsData: action.payload.mobileAdsData,
        // headScripts: action.payload.headScripts,
        // headStyles: action.payload.headStyles,
        // story: action.payload.story,
        data: articleShowData,
      };
    }
    case RECEIVE_SECTION_DATA: {
      const prevMsidMappingData = state.msidmappingdata || {};
      const msidmapping = { ...prevMsidMappingData, ...action.payload.data };

      return {
        ...state,
        msidmappingdata: msidmapping,
      };
    }
    case POPULATE_ARTICLESHOW_WIDGETS: {
      const articleShowData = state.data ? { ...state.data } : {};
      const articleData = articleShowData[action.payload.msid];
      const msidmapping = state.msidmappingdata;

      const bodyInserts = getBodyInserts(
        action.payload.sectionInfo || {},
        action.payload.isMobile,
      );

      if (msidmapping && articleData) {
        Object.keys(articleData).forEach(key => {
          if (
            articleData[key] &&
            typeof articleData[key] === 'object' &&
            articleData[key].msid_mapping_id
          ) {
            const mappingId = articleData[key].msid_mapping_id;

            if (msidmapping[mappingId]) {
              if (
                articleData[key].isCloudServiceData &&
                !articleData[key].name
              ) {
                const widgetTitle =
                  Array.isArray(msidmapping[mappingId]) &&
                  msidmapping[mappingId].length > 0 &&
                  msidmapping[mappingId][0].widgetTitle;
                articleData[key].name = widgetTitle;
              }
              articleData[key] = {
                ...articleData[key],
                items: msidmapping[mappingId],
              };
            }
          }
        });
      }

      if (
        articleData &&
        Array.isArray(articleData.story) &&
        Array.isArray(bodyInserts)
      ) {
        // Group inserts by position
        const insertsByPosition = bodyInserts.reduce((map, insert) => {
          if (!map[insert.position]) {
            map[insert.position] = [];
          }
          map[insert.position].push(insert);
          return map;
        }, {});

        const newStory = [];

        let isCityPage = false;
        let isCityDataPageUrlVisible = false;
        let cityName;
        let cityMsid;
        if (
          articleData.navsubsecs &&
          articleData.navsubsecs.subsec1 &&
          articleData.navsubsecs.subsec1.subsecmsid1
        ) {
          isCityPage =
            articleData.navsubsecs.subsec1.subsecmsid1 === '-2128932452';
          if (
            isCityPage &&
            articleData.navsubsecs &&
            articleData.navsubsecs.subsec2 &&
            articleData.navsubsecs.subsec2.subsecname2 &&
            articleData.navsubsecs.subsec2.subsecmsid2
          ) {
            cityName = articleData.navsubsecs.subsec2.subsecname2;
            cityMsid = articleData.navsubsecs.subsec2.subsecmsid2;
          }
        }

        if (
          articleData &&
          articleData.metaInfo &&
          articleData.metaInfo.categorytags
        ) {
          isCityDataPageUrlVisible =
            articleData.metaInfo.categorytags === 'No AQI';
        }

        // const brIndices = articleData.story
        //   .map((item, index) => (item.type === 'br' ? index : -1))
        //   .filter(index => index !== -1);

        if (
          isCityPage &&
          cityName &&
          cityMsid &&
          typeof cityName === 'string' &&
          !isCityDataPageUrlVisible &&
          readAlsoWidgetApplicableCities.includes(cityMsid)
        ) {
          const cityUrlMapping = readAlsoWidgetCityMapping(cityName);
          // if (brIndices.length >= 3) {
          // const thirdParaIndex = brIndices[2];

          articleData.story.push({
            type: 'cdata',
            scripts: null,
            value: `<strong>You Can Also Check: <a href=${
              cityUrlMapping?.aqi
            }>${cityName} AQI</a> | <a href="${
              cityUrlMapping?.bank_holiday
            }">Bank Holidays in ${cityName}</a> | <a href="${
              cityUrlMapping?.gold
            }">Gold Rate Today in ${cityName}</a> | <a href="${
              cityUrlMapping?.silver
            }">Silver Rate Today in ${cityName}</a></strong>`,
          });
        }
        // }

        articleData.story.forEach(item => {
          if (item.type === 'body_insert' && insertsByPosition[item.pos]) {
            // Get all inserts for this position
            const positionInserts = insertsByPosition[item.pos];
            // Add all inserts for this position
            positionInserts.forEach(insert => {
              let insertData = insert.data || {};
              if (insert.widgetRef && articleData[insert.widgetRef]) {
                insertData = {
                  ...insertData,
                  ...articleData[insert.widgetRef],
                };
              }

              newStory.push({
                ...item,
                pos: item.pos - 1,
                type: insert.type || item.type,
                ...insertData,
              });
            });
          } else {
            newStory.push(item);
          }
        });

        // Special insert positions ( start and end )
        const processInserts = inserts =>
          inserts.map(insert => {
            let insertData = insert.data || {};
            if (insert.widgetRef && articleData[insert.widgetRef]) {
              insertData = {
                ...insertData,
                ...articleData[insert.widgetRef],
              };
            }
            return {
              ...insert,
              ...insertData,
            };
          });

        if (insertsByPosition.start) {
          const newStartInserts = processInserts(insertsByPosition.start);
          newStory.unshift(...newStartInserts);
        }

        if (insertsByPosition.end) {
          const newEndInserts = processInserts(insertsByPosition.end);
          newStory.push(...newEndInserts);
        }

        articleData.story = newStory;
      }

      if (articleData) {
        articleData.disableLoginBlocker = true;
      }

      articleShowData[action.payload.msid] = articleData;
      return {
        ...state,
        data: articleShowData,
      };
    }
    case PERPETUAL_DATA: {
      const { cardsObj = null, msid, grxInfo } = action.payload;
      const CardsArray = cardsObj?.cards || [];
      const updatedCardsArray =
        Array.isArray(CardsArray) &&
        CardsArray.length > 0 &&
        CardsArray.filter(value => value.id.toString() !== msid);
      const perpetualStoriesToLoad = Math.min(3, updatedCardsArray?.length);
      const updatedperpetualData =
        Array.isArray(updatedCardsArray) &&
        updatedCardsArray.length > 0 &&
        updatedCardsArray.slice(0, perpetualStoriesToLoad);

      return {
        ...state,
        perpetualData: updatedperpetualData || null,
        upNextGrxInfo: grxInfo,
      };
    }
    case HANDLE_UP_NEXT_ERROR: {
      return {
        ...state,
        upNextGrxInfo: action.payload,
      };
    }
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }

    case RECEIVE_CARDS_INSERT_LITE_DATA: {
      return {
        ...state,
        cardsInsertsLite: action.payload,
      };
    }
    // case NIC_LOADING: {
    //   return {
    //     ...state,
    //     nicLoading: true,
    //   };
    // }
    // case NIC_LOADED: {
    //   return {
    //     ...state,
    //     nicLoading: false,
    //   };
    // }
    // case TOGGLE_NIC: {
    //   return {
    //     ...state,
    //     isNicOpen: action.payload.isNicOpen,
    //   };
    // }
    // case RECEIVE_DATA_NIC: {
    //   return {
    //     ...state,
    //     nic: action.payload.nic,
    //   };
    // }
    case ADD_DOCK_CANDIDATE: {
      return {
        ...state,
        dockCandidate: action.payload.data,
      };
    }
    case ADD_UNDOCK_CANDIDATE: {
      return {
        ...state,
        unDockCandidate: action.payload.data,
      };
    }
    case DELETE_DOCK_CANDIDATE: {
      return {
        ...state,
        dockCandidate: undefined,
      };
    }
    case DELETE_UNDOCK_CANDIDATE: {
      return {
        ...state,
        unDockCandidate: undefined,
      };
    }
    case HANDLE_CARDS_INSERTS_DATA_LITE_ERROR: {
      return {
        ...state,
        cardsInsertsLite: {},
      };
    }
    case OPEN_VIDEO_THEATRE: {
      return {
        ...state,
        isVideoTheatreOpen: true,
        videoTheatreSliderPath: action.payload.videoTheatreSliderPath,
        videoTheatreCurrMsid: action.payload.videoTheatreCurrMsid,
        videoTheatreCurrItem: action.payload.videoTheatreCurrItem,
      };
    }
    case CLOSE_VIDEO_THEATRE: {
      return {
        ...state,
        isVideoTheatreOpen: false,
        videoTheatreSliderPath: undefined,
      };
    }
    case LOAD_MINITV_COMPONENT: {
      return {
        ...state,
        loadedMiniTvComponent: action.payload,
      };
    }
    case RECEIVE_DATA_VIDEO_THEATRE_SLIDER: {
      return {
        ...state,
        videoTheatreSliderData: action.payload.data.data.items,
      };
    }
    case ADD_NEXT_VIDEO_MSID: {
      return {
        ...state,
        msidForNextVideo: action.payload.msidForNextVideo,
        slikeId: action.payload.slikeId,
      };
    }
    case ELECTIONS_DATA_LOADED: {
      return {
        ...state,
        electionsData: action.payload || {},
      };
    }
    case EXITPOLL_DATA_LOADED: {
      return {
        ...state,
        exitPollData: action.payload || {},
      };
    }
    case ASBREIFS_DATA_LOADED: {
      return {
        ...state,
        asBriefsData: action.payload,
      };
    }
    // case ASNEWSCOVERAGE_DATA_LOADED: {
    //   return {
    //     ...state,
    //     newsCoverageData: action.payload,
    //   };
    // }
    case GEOLOCATION_VALUE: {
      return {
        ...state,
        geolocationValue: action.payload.geolocationValue || 1,
      };
    }
    case ACTIVE_MSID: {
      return {
        ...state,
        activemsid: action.payload.activemsid,
      };
    }
    case NIC_TEXT: {
      return {
        ...state,
        nicLabel: action.payload.text,
      };
    }
    case ARTICLE_TO_SHOW_COUNT: {
      return {
        ...state,
        articleToShowCount: action.payload,
      };
    }
    case ARTICLE_TO_SHOW_RESET_DAYS: {
      return {
        ...state,
        articleToShowResetDays: action.payload,
      };
    }
    case RECEIVE_DATA_RELATED_ARTICLES: {
      return {
        ...state,
        relatedArticles: action.payload,
      };
    }
    case OPEN_MWEB_SEARCH: {
      return {
        ...state,
        isSearchOpenedFrmMidArticle: action.payload,
      };
    }
    case SET_IS_ORGANIC: {
      return {
        ...state,
        isOrganic: action.payload,
      };
    }
    case SET_IS_PAID_TRAFFIC: {
      return {
        ...state,
        isPaidTraffic: action.payload,
      };
    }

    case SHOW_SEARCH_OVERLAY: {
      return {
        ...state,
        isShowSearchOverlay: action.payload,
      };
    }
    case RECEIVE_CARDS_DATA: {
      const cardsData = [];
      cardsData.push(action.payload.inserts?.persuasion.cards);

      return { ...state, cardsData };
    }
    // case RECEIVE_BUNDLE_CARDS_DATA: {
    //   return {
    //     ...state,
    //     bundleCardsLiteData: action.payload.data,
    //     bundleUrl: action.payload.bundleUrl,
    //   };
    // }
    case RECIEVE_BUNDLE_HASHTAG_DATA: {
      return {
        ...state,
        decode: action.payload.decode,
      };
    }
    case RECEIVE_BOARD_DATA: {
      return {
        ...state,
        boardresultdata: action.payload,
      };
    }
    case RECEIVE_BOARD_DATA_ERROR: {
      return {
        ...state,
        boardresultdata: {},
        boardresultdataerror: action.error,
      };
    }
    case RECEIVE_TRIBUTE_SHOW_DATA: {
      return {
        ...state,
        tributeShowData: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
